/*!
 * Copyright (c) Trimble Inc. All rights reserved
 */

import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SysqueCheckBoxContainerComponent } from './sysque-check-box-container.component';

@NgModule({
  declarations: [SysqueCheckBoxContainerComponent],
  imports: [CommonModule],
  exports: [SysqueCheckBoxContainerComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SysqueCheckBoxContainerModule {}
